import { parseQuery } from '../../utils/query'
import {
  getLocalStorageItem,
  LocalStorageKey,
  removeLocalStorageItem,
  setLocalStorageItem,
} from '../../utils/local-storage'

type Experiments = { [key: string]: string }

const parseToExperimentObj: (experiments: string) => Experiments = (experiments: string) => {
  return !experiments
    ? {}
    : experiments.split(',').reduce((acc, val) => {
        const tuple = val.split(':')
        return tuple.length < 2 ? { ...acc } : { ...acc, [tuple[0]]: tuple[1] }
      }, {})
}

const localStorageFallbackOverrides: () => Experiments = () => {
  const localStorageEntry = getLocalStorageItem(LocalStorageKey.grammarlyExperimentOverrides)
  return localStorageEntry ? parseToExperimentObj(localStorageEntry) : {}
}

export const getExperimentOverrides: () => Experiments = () => {
  let parsedExperimentOverrides = {}
  const { experimentOverrideReset, experimentOverrides, experimentsReset, experiments } = parseQuery(
    window.location.search
  )

  if (experimentOverrideReset || experimentsReset) {
    removeLocalStorageItem(LocalStorageKey.grammarlyExperimentOverrides)
  }
  try {
    if (!experimentOverrides && !experiments) {
      return localStorageFallbackOverrides()
    }

    parsedExperimentOverrides = parseToExperimentObj(experimentOverrides || experiments)
    setLocalStorageItem(LocalStorageKey.grammarlyExperimentOverrides, experimentOverrides || experiments)

    return parsedExperimentOverrides
  } catch (e) {
    console.error('Error with experiment override setting. Please check your params.', e)
  }
  return parsedExperimentOverrides
}
